import * as React from "react";
const SvgMinus = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fill="var(--icon-primary)" d="M6 11h12v2H6z" /></svg>;
export default SvgMinus;